<template>
  <v-ons-page>

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">
        {{ cultLabel }}
      </div>
    </v-ons-toolbar>

    <div class="content">

      <img :src="negoceImg + '.png'" :srcset="negoceImg + '@2x.png 2x'" class="perfnegoce" />
      <v-ons-list modifier="noborder perflist">

        <v-ons-list-item v-if="apport.id" modifier="nodivider perfcours">
          <div class="center">Numéro du bon</div>
          <div class="right">{{ apport.id }}</div>
        </v-ons-list-item>

        <v-ons-list-item modifier="nodivider perfcours">
          <div class="center">Date de livraison</div>
          <div class="right">{{ getDateLabelFromIso(apport.date) }}</div>
        </v-ons-list-item>
        
        <v-ons-list-item v-if="clientInfos" modifier="nodivider perfcours">
          <div class="center">Exploitation</div>
          <div class="right">{{ clientInfos }}</div>
        </v-ons-list-item>

        <v-ons-list-item modifier="nodivider perfcours">
          <div class="center">Campagne</div>
          <div class="right">{{ campagne }}</div>
        </v-ons-list-item>

        <v-ons-list-item modifier="nodivider perfcours">
          <div class="center">Culture</div>
          <div class="right">{{ apportLabel ? apportLabel : cultLabel }}</div>
        </v-ons-list-item>

        <v-ons-list-item v-if="apport.brut" modifier="perfcours">
          <div class="center">Poids brut</div>
          <div class="right">{{ apport.brut.toLocaleString('fr', { minimumFractionDigits: 3 }) }} t</div>
        </v-ons-list-item>

        <v-ons-list-item v-if="apport.net" modifier="perfcours">
          <div class="center">Poids net</div>
          <div class="right">{{ apport.net.toLocaleString('fr', { minimumFractionDigits: 3 }) }} t</div>
        </v-ons-list-item>

        <v-ons-list-item modifier="perfcours">
          <div class="center">Poids aux normes</div>
          <div class="right">{{ apport.tonne.toLocaleString('fr', { minimumFractionDigits: 3 }) }} t</div>
        </v-ons-list-item>

        <v-ons-list-item v-if="isApportDetail" modifier="nodivider perfcours" expandable :expanded.sync="isShowDetail">
          <div class="center">
            Caractéristiques
          </div>
          <div class="right">
            <span class="list-item__expand-chevron"></span>
          </div>
          <div class="expandable-content">
            <v-ons-list modifier="noborder nopadding">
              <v-ons-list-item v-if="apport.ps != undefined" modifier="perfcours">
                <div class="center">Poids spécifique</div>
                <div class="right">{{ apport.ps.toLocaleString('fr') }}</div>
              </v-ons-list-item>
              <v-ons-list-item v-if="apport.h2o != undefined" modifier="perfcours">
                <div class="center">Humidité</div>
                <div class="right">{{ apport.h2o.toLocaleString('fr') }}</div>
              </v-ons-list-item>
              <v-ons-list-item v-if="apport.imp != undefined" modifier="perfcours">
                <div class="center">Impuretés</div>
                <div class="right">{{ apport.imp.toLocaleString('fr') }}</div>
              </v-ons-list-item>
              <v-ons-list-item v-if="apport.prot != undefined" modifier="perfcours">
                <div class="center">Protéines</div>
                <div class="right">{{ apport.prot.toLocaleString('fr') }}</div>
              </v-ons-list-item>
            </v-ons-list>
          </div>
        </v-ons-list-item>

      </v-ons-list>
      
    </div>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from '../store.js';

export default {
  mixins: [mixinsCommons, mixinsCours],
  props: ['pageStack'],
  data() {
    return {
      negoceId: '',
      refCulture: '',
      refDestination: '',
      apport: {},
      isShowDetail: false,
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    campagne() {
      return this.user.campagne;
    },
    referentiel() {
      return this.data.referentiel;
    },
    cultLabel(){
      return this.getCultLabel();
    },
    negoceInfos() { // undefined si autre OS
      return this.getNegoceAcces(this.data.negoce.list, this.negoceId);
    },
    clientInfos() {
      if(this.negoceInfos){
        if(this.negoceInfos.clients) {
          return this.negoceInfos.clients[this.apport.client];
        }
      }
      return null;
    },
    apportLabel() {
      if(this.negoceInfos){
        return this.negoceInfos.apport.produit[this.apport.produit];
      }
    },
    isApportDetail(){
      return this.apport.ps != undefined || this.apport.h2o != undefined || this.apport.imp != undefined || this.apport.prot != undefined;
    }
  },
  mounted() {
    if(this.isApportDetail) {
      this.isShowDetail = true;
    }
  }
}
</script>